/* eslint-disable import/prefer-default-export */

import { AgreementApiModel } from './models/DealModel';

export const PMI_WELCOME_VIDEO_URL =
  'https://www.youtube.com/watch?v=8HXyEIJ5gHQ';

const DEAL_PAYMENT_MAP = {
  'Pay on Consumption': 'Billed Monthly',
  'On Consumption - Invoiced Periodically': 'Billed Monthly',
  'On Consumption-Invoiced Periodically': 'Billed Monthly',
  'Pay up front': 'Payment in Advance',
  'Pay Upfront': 'Payment in Advance',
  'Pay By User': 'Pay By User',
  PayByUser: 'Pay By User',
};

export const PAY_BY_USER_STATUS_MAP = {
  inCart: 'in cart',
  addToCart: 'add to cart',
  renew: 'renew',
};

export enum DisabledReason {
  B2CPurchase = 'B2CPurchase',
  MembershipExpired = 'MembershipExpired',
}

export const isPayByUserCartStatus = (text: string): boolean =>
  Object.values(PAY_BY_USER_STATUS_MAP).includes(text?.toLowerCase().trim());

export const mapPaymentArrangementText = (deal: AgreementApiModel) => {
  if (!deal.paymentArrangement) {
    return null;
  }
  const sanitized = deal.paymentArrangement.replace('(DO NOT USE)', '').trim();
  let text = DEAL_PAYMENT_MAP[sanitized] ?? null;
  if (!text) {
    const key = Object.keys(DEAL_PAYMENT_MAP).find((k) =>
      deal.paymentArrangement
        .toString()
        .toLowerCase()
        .includes(k.toString().toLowerCase()),
    );
    text = key ? DEAL_PAYMENT_MAP[key] : deal.paymentArrangement;
  }
  return text;
};

export const isPayByUser = (paymentArrangement: string) =>
  ['pay by user', 'paybyuser'].includes(
    paymentArrangement?.toLocaleLowerCase(),
  );

export const estimatedQuantityTitle = (paymentArrangement: string) => {
  if (paymentArrangement?.toLocaleLowerCase() === 'pay up front')
    return 'Quantity';
  return 'Est. Quantity';
};

export const estimatedTotalTitle = (paymentArrangement: string) => {
  if (paymentArrangement?.toLocaleLowerCase() === 'pay up front')
    return 'Committed Total';
  return 'Estimated Total';
};

export const ADMIN_HELPURL =
  'https://scribehow.com/o/niAUlPt_Ss2KrLycOfgVnA/page/PMI_Partner_Platform_Administrator_Guide__-jzpHU48RJCI_dPR1pVsoA';
export const HUB_HELPURL =
  'https://scribehow.com/page/PMI_Partner_Platform_Learner_User_Guide__iRv0HbsoSwKhRYkptNbYyQ';

interface ProductType {
  certification: string;
  membership: string;
  chapterMembership: string;
  digitalProduct: string;
  onlineCourse: string;
}

export const MembershipSku01: string = 'MEMB-B-01';
export const MembershipSku02: string = 'MEMB-B-02';

export const ProductTypes: Readonly<ProductType> = {
  certification: 'Certification',
  membership: 'Membership',
  chapterMembership: 'Chapter Membership',
  digitalProduct: 'Digital Product',
  onlineCourse: 'eLearning',
};

export const PLATFORM_TOUR_SESSION_STORAGE_KEY = 'platformTourSession';

export const benefitsItems = [
  'Up to <b>30% off</b> certifications (including renewals) and eLearning',
  'Free downloads of the <b><i>PMBOK® Guide</i></b> and other PMI standards',
  'Free <b>eLearning courses</b> to upskill in AI and more',
  '<b>PMI Infinity™</b> AI-powered coach',
];
